<template>
    <van-popup
        v-if="addFollowTplPopupShow"
        :value="addFollowTplPopupShow"
        z-index="100"
        :close-on-click-overlay="false"
        :style="{ height: '100vh', width: '100vw', background: 'rgba(0,0,0,.3)' }"
        overlay-class="custom_popup"
        position="right"
    >
        <div class="public_container customer_add_wrap">
            <div class="returnNavBar">
                <div class="returnNavBarLeft" @click="handleClickClose">
                    <van-icon  name="arrow-left" />
                    <span class="normal_title">返回</span>
                </div>
            </div>
            <div class="mobile_container" v-loading="loading">
                <CustomFormMobile
                    ref="crm_custom_form"
                    :field_list="formInfoList"
                    :is_form_module="true"
                    @submit-form="submitFormData"
                    v-if="dataLoaded"
                />
            </div>
            <div class="add_footer_wrap">
                <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm"
                    >确定</van-button
                >
            </div>
        </div>
    </van-popup>
</template>

<script>
import { getFormFields, customerPrivateFollowUpAdd } from "@/api";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile";
export default {
    name: "MCustomerFollowTpl",
    components: { CustomFormMobile },
    props: {
        addFollowTplPopupShow: {
            type: Boolean,
            default: false
        },
        customer_id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: false,
            formInfoList: [],
            dataLoaded: false,
            btnDisabled: false,
        };
    },
    created() {
        this._getFromFields();
    },
    methods: {
        handleClickClose() {
            this.$emit("update:addFollowTplPopupShow", false)
        },
        //表单字段获取
        _getFromFields() {
            this.loading = true;
            getFormFields({
                field_form: "customer_follow_ups",
            }).then((res) => {
                if (res.code === 200) {
                    this.formInfoList = res.data;
                    this.loading = false;
                    this.dataLoaded = true;
                }
            });
        },
        handleClickConfirm() {
            this.$refs.crm_custom_form.handleClickPublish();
        },
        submitFormData(customForm) {
            if (customForm) {
                const form = {
                    customer_id: this.customer_id,
                    ...customForm,
                };
                customerPrivateFollowUpAdd(form)
                    .then((res) => {
                        this.loading = false;
                        this.btnDisabled = false;
                        if (res.code == 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.$emit("update:addFollowTplPopupShow", false)
                                    this.$emit("addFollowTplSuccess")
                                },
                            });
                        } else {
                            this.$toast({
                                message: res.message,
                                type: "fail",
                            });
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        this.btnDisabled = false;
                    });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.customer_add_wrap {
    .mobile_container {
        padding: 10px 0;
    }
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: #f7f8fa;

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
}
</style>
